import React from 'react'
import "./hero.css"
import { Link } from "react-router-dom/cjs/react-router-dom"

const Mobile = () => {
  // Handler for transparent clicker
  const handleClicker = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.frtholdingsmw.mlimi&pcampaignid=web_share",
      "_blank"
    );
  };

  return (
    <>
      <div className='w-full flex h-screen items-start heromobile' style={{position: "relative"}}>
        {/* ...your main content here... */}

        {/* Transparent Clicker */}
        <div
          className="mobile-clicker"
          onClick={handleClicker}
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "100%",
            height: "30%",
            cursor: "pointer",
            zIndex: 50,
            background: "transparent"
          }}
        />
      </div>
    </>
  )
}

export default Mobile
